
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanConeDown as ObiBuoyCanConeDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-cone-down.js';
 
 
 

 
 export const ObiBuoyCanConeDown = createComponent({
   react: React,
   tagName: 'obi-buoy-can-cone-down',
   elementClass: ObiBuoyCanConeDownElement,
   events: {
     
   }
  });
 
 